export { BrowserSentryAdapter } from './BrowserSentryAdapter';
